// CSS Modules - component class name: MobileMenu__

<template>
  <nav :class="$style.drawer">
    <Slide right disableOutsideClick>
      <ul v-if="!isShop" :class="$style.primaryNav">
        <li v-for="elm in primaryLinks" :key="elm.title + elm.id">
          <a :class="{ MobileMenu__active: elm.isActive }" :href="elm.url">{{ elm.title }}</a>
          <bulma-accordion icon="custom" :slide="{ duration: '300ms', timerFunc: 'ease' }">
            <bulma-accordion-item v-for="subElm in elm.subNav" :key="subElm.title + subElm.id">
              <span slot="title" v-html="subElm.title"></span>
              <span slot="icon" :class="$style.icon"></span>
              <p slot="content">
                <ul :class="$style.subNav" v-for="column in subElm.subNav" :key="column.title + column.id">
                  <span v-html="column.title"></span>
                  <li v-for="link in column.subNav" :key="link.title + link.id">
                    <a :href="link.url" v-html="link.title"></a>
                  </li>
                </ul>
              </p>
            </bulma-accordion-item>
          </bulma-accordion>
        </li>
      </ul>
      <ul v-if="isShop" :class="$style.primaryNav">
        <li v-for="elm in primaryLinks" :key="elm.title + elm.id">
          <a :class="{ MobileMenu__active: elm.isActive }" :href="elm.url" v-html="elm.title"></a>
          <ul :class="$style.subNav">
            <li v-for="link in elm.subNav" :key="link.title + link.id">
              <a :href="link.url" v-html="link.title"></a>
            </li>
          </ul>
        </li>
      </ul>
      <ul :class="$style.secondaryNav">
        <li v-for="elm in secondaryLinks" :key="elm.title + elm.id">
          <a :class="{ MobileMenu__active: elm.isActive }" :href="elm.url" v-html="elm.title"></a>
          <ul :class="$style.subNav">
            <li v-for="link in elm.subNav" :key="link.title + link.id">
              <a :href="link.url" v-html="link.title"></a>
            </li>
          </ul>
        </li>
      </ul>
    </Slide>
  </nav>
</template>

<script>
import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion";
import { Slide } from 'vue-burger-menu';

export default {
  name: "MobileMenu",
  components: {
    BulmaAccordion,
    BulmaAccordionItem,
    Slide
  },
  props: {
    isShop: {
      type: Boolean,
      default: false
    },
    primaryLinks: {
    	type: Array,
      default: () => []
    },
    secondaryLinks: {
    	type: Array,
      default: () => []
    }
  }
};
</script>

<style module lang="scss">
@import "./MobileMenu.scss";
</style>
